// extracted by mini-css-extract-plugin
export var campSection = "CampSection-module--campSection--b15f3";
export var campSection_button = "CampSection-module--campSection_button--0e01b";
export var campSection_button_link = "CampSection-module--campSection_button_link--a6a9f";
export var campSection_detail = "CampSection-module--campSection_detail--bd21c";
export var campSection_heading = "CampSection-module--campSection_heading--0b60b";
export var campSection_image = "CampSection-module--campSection_image--012a7";
export var campSection_inner = "CampSection-module--campSection_inner--e2114";
export var campSection_item = "CampSection-module--campSection_item--8b350";
export var campSection_lead = "CampSection-module--campSection_lead--4c66d";
export var campSection_text = "CampSection-module--campSection_text--47b18";
export var caption = "CampSection-module--caption--bc023";
export var caption__white = "CampSection-module--caption__white--8d3f1";
export var disable = "CampSection-module--disable--6067c";
export var inner__sp = "CampSection-module--inner__sp--73a3d";
export var small = "CampSection-module--small--d3cd3";